import { render, staticRenderFns } from "./TheSplashscreenHeader.vue?vue&type=template&id=648d90ff&scoped=true&"
import script from "./TheSplashscreenHeader.vue?vue&type=script&lang=js&"
export * from "./TheSplashscreenHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheSplashscreenHeader.vue?vue&type=style&index=0&id=648d90ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648d90ff",
  null
  
)

export default component.exports